// extracted by mini-css-extract-plugin
module.exports = {"slideContainer":"SwipeContainer_slideContainer__3Q9pr"};